import { useEffect, useRef } from 'react';
import { useRevalidator } from 'react-router';

import { useCurrency } from '../context/Currency';

export const useCurrencyRevalidator = () => {
  const { revalidate } = useRevalidator();
  const currency = useCurrency();

  const currencyRef = useRef(currency);

  useEffect(() => {
    if (currency !== currencyRef.current) {
      currencyRef.current = currency;
      revalidate();
    }
  }, [revalidate, currency]);
};
